import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Stack, Typography } from '@mui/material'
import DOMPurify from 'dompurify'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { clampCss, ICONS, LinkUnstyled, unit } from '@hcr/ui'

import { Path, EMPTY_PATH_PARAM } from '../../../../models'
import { to } from '../../../../utils'
import { DestinationDrawerLink } from '../destination-drawer-link'

interface DestinationInfoProps {
  description: string
  destinationId: string
  openDrawer: () => void
}

export const DestinationInfo: FC<DestinationInfoProps> = ({ description, destinationId, openDrawer }) => {
  const { t } = useTranslation()

  return (
    <>
      <Stack direction='row' alignItems='center' gap={unit(2)}>
        <FontAwesomeIcon icon={ICONS.farInfoCircle} />
        <Typography component='h2' variant='titleS'>
          {t('home.destination-info')}
        </Typography>
      </Stack>
      <Box>
        <Typography
          variant='bodyM'
          css={clampCss(4)}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
        />
        <DestinationDrawerLink onClick={openDrawer}>
          <Typography component='u' variant='textLinkM'>
            {t('home.read-more')}
          </Typography>
          <FontAwesomeIcon icon={ICONS.farArrowDown} />
        </DestinationDrawerLink>
      </Box>
      <Button
        component={LinkUnstyled}
        to={to([Path.Services, { destinationId: destinationId ?? EMPTY_PATH_PARAM }])}
        variant='outlined'
        color='white'
      >
        {t('home.explore-services')}
      </Button>
    </>
  )
}
